import * as React from 'react';
import Table from './Table';
import ManagerBase from '../../../Employee/Profile/ApproverFor/Manager';

export default class Manager extends ManagerBase {
    getTable(employees: any) {
        return (<Table employee={this.props.employee} employees={employees} />);
    }
}